var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHeartFavorite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 13.8379C7.91905 13.8379 7.83815 13.817 7.76565 13.7751C7.6869 13.7296 5.81594 12.6433 3.91813 11.0065C2.79332 10.0364 1.89545 9.07425 1.24951 8.14675C0.413642 6.94657 -0.00670047 5.79214 8.07524e-05 4.71548C0.00801823 3.46268 0.456735 2.28449 1.26367 1.39793C2.08423 0.496436 3.17929 0 4.34719 0C5.84397 0 7.21243 0.838435 8.00002 2.16662C8.78761 0.838466 10.1561 0 11.6529 0C12.7562 0 13.8089 0.447936 14.6172 1.26131C15.5042 2.1539 16.0082 3.41508 15.9999 4.72142C15.9931 5.7962 15.5649 6.94888 14.7272 8.14741C14.0792 9.07444 13.1826 10.0362 12.0622 11.006C10.1713 12.6426 8.3138 13.7289 8.23565 13.7744C8.1628 13.8167 8.08137 13.8379 7.99999 13.8379Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartFavorite);
export default __webpack_public_path__ + "static/media/icon-heart-favorite.ba10f2cfe6d0f9a84c6252c08b8ff4be.svg";
export { ForwardRef as ReactComponent };